import {
  addObj,
  getAll,
  searchByName,
  getPage,
  getDetail,
  modifyObj,
  deleteObj
} from '@/api/vehicleownerinfoserv'

export default {
  state: {
    state_VehicleOwnerInfo_AddObjResult: null,
    state_VehicleOwnerInfo_GetAllResult: null,
    state_VehicleOwnerInfo_SearchByNameResult: null,
    state_VehicleOwnerInfo_GetPageResult: null,
    state_VehicleOwnerInfo_GetDetailResult: null,
    state_VehicleOwnerInfo_ModifyObjResult: null,
    state_VehicleOwnerInfo_DeleteObjResult: null
  },
  mutations: {
    SET_VEHICLEOWNERINFO_ADDOBJ_RESULT: (state, rst) => {
      state.state_VehicleOwnerInfo_AddObjResult = rst
    },
    SET_VEHICLEOWNERINFO_GETALL_RESULT: (state, rst) => {
      state.state_VehicleOwnerInfo_GetAllResult = rst
    },
    SET_VEHICLEOWNERINFO_SEARCHBYNAME_RESULT: (state, rst) => {
      state.state_VehicleOwnerInfo_SearchByNameResult = rst
    },
    SET_VEHICLEOWNERINFO_GETPAGE_RESULT: (state, rst) => {
      state.state_VehicleOwnerInfo_GetPageResult = rst
    },
    SET_VEHICLEOWNERINFO_GETDETAIL_RESULT: (state, rst) => {
      state.state_VehicleOwnerInfo_GetDetailResult = rst
    },
    SET_VEHICLEOWNERINFO_MODIFYOBJ_RESULT: (state, rst) => {
      state.state_VehicleOwnerInfo_ModifyObjResult = rst
    },
    SET_VEHICLEOWNERINFO_DELETEOBJ_RESULT: (state, rst) => {
      state.state_VehicleOwnerInfo_DeleteObjResult = rst
    }
  },
  actions: {
    VehicleOwnerInfoServ_AddObj ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        addObj(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_VEHICLEOWNERINFO_ADDOBJ_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_VEHICLEOWNERINFO_ADDOBJ_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    VehicleOwnerInfoServ_GetAll ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getAll(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_VEHICLEOWNERINFO_GETALL_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_VEHICLEOWNERINFO_GETALL_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    VehicleOwnerInfoServ_SearchByName ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        searchByName(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_VEHICLEOWNERINFO_SEARCHBYNAME_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_VEHICLEOWNERINFO_SEARCHBYNAME_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    VehicleOwnerInfoServ_GetPage ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getPage(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_VEHICLEOWNERINFO_GETPAGE_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_VEHICLEOWNERINFO_GETPAGE_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    VehicleOwnerInfoServ_GetDetail ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getDetail(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_VEHICLEOWNERINFO_GETDETAIL_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_VEHICLEOWNERINFO_GETDETAIL_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    VehicleOwnerInfoServ_ModifyObj ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        modifyObj(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_VEHICLEOWNERINFO_MODIFYOBJ_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_VEHICLEOWNERINFO_MODIFYOBJ_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    VehicleOwnerInfoServ_DeleteObj ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        deleteObj(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_VEHICLEOWNERINFO_DELETEOBJ_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_VEHICLEOWNERINFO_DELETEOBJ_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    }
  },
  getters: {
    get_VehicleOwnerInfo_AddObjResult: state => {
      return state.state_VehicleOwnerInfo_AddObjResult
    },
    get_VehicleOwnerInfo_GetAllResult: state => {
      return state.state_VehicleOwnerInfo_GetAllResult
    },
    get_VehicleOwnerInfo_SearchByNameResult: state => {
      return state.state_VehicleOwnerInfo_SearchByNameResult
    },
    get_VehicleOwnerInfo_GetPageResult: state => {
      return state.state_VehicleOwnerInfo_GetPageResult
    },
    get_VehicleOwnerInfo_GetDetailResult: state => {
      return state.state_VehicleOwnerInfo_GetDetailResult
    },
    get_VehicleOwnerInfo_ModifyObjResult: state => {
      return state.state_VehicleOwnerInfo_ModifyObjResult
    },
    get_VehicleOwnerInfo_DeleteObjResult: state => {
      return state.state_VehicleOwnerInfo_DeleteObjResult
    }
  }
}
